// src/hooks/paxTypes/useGetPaxType.js
import { useQuery } from "@tanstack/react-query";
import { getPaxType } from "../../api/apiPaxTypes";

const QUERY_KEY = ["paxType"];

const useGetPaxType = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getPaxType(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    paxType: data?.data || null,
  };
};

export default useGetPaxType;